import { useParams } from "react-router-dom";
import { EVALUATION_TYPES } from "../../../../../components/dashboard/hse/evaluation/evaluationUtils";
import { EvaluationForm } from "../../../../../components/dashboard/hse/evaluation/EvaluationForm";

export const HseKsManagementReviewEdit = () => {
  const { id } = useParams();
  return <EvaluationForm evaluationType={EVALUATION_TYPES.MANAGEMENT_REVIEW} id={id} />;
};
